import styled from "styled-components";
import { FlexWrapper } from "../popUp/PopUp.styles";

export const MainContainer = styled.section`
    display: ${props => props.display ? props.display : "none"};
    padding: 15px 32px;
    align-items: center;
    gap: var(--24px, 24px);
    border-radius: 0px 0px var(--12px, 12px) var(--12px, 12px);
    background: var(--Status-YELLOW-100, #FECB00);
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.15);
    width: 100%;
    position: absolute;
    top: 0;
    justify-content: space-between;
    z-index: 200;

    @media (max-width: 768px) {
      margin-top: 82px;
    }
    @media (max-width: 426px) {
      ${FlexWrapper} {
        flex-wrap: wrap;
      }
    }

}
`;

export const IconHiddenOnMobile = styled.img`
@media (max-width: 426px) {
    display: none;
  }
`;
